import React from 'react';
import { useEffect } from 'react';
import { HashimotoTestEdge, useTranslator, withLoading } from '@front-activerse/common-components';
import { Col, Container, Row, NavItem, Nav } from 'reactstrap';
import { useParams, NavLink } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import createMeasurements from '../Helpers/createMeasurements';
import { HashimotoTestMeasurementFieldEnum, TestMeasurement } from '../types';
import groupByYear from '../Helpers/groupMeasurementByYear';
import LabTestsHistoryItem from './LabTestsHistoryItem';
import TestsHistoryPlaceholder from './LabTestsHistoryPlaceholder';

interface ITestsHistoryContainer {
  hashimotoTestHistory: HashimotoTestEdge[];
  removeTest: any;
}

const TestsHistoryContainer: React.FC<ITestsHistoryContainer> = ({
  hashimotoTestHistory,
  removeTest,
}) => {
  const { t } = useTranslator();
  const { category } = useParams<{ category: HashimotoTestMeasurementFieldEnum }>();

  useEffect(() => {
    // trackFirebaseEvent('screen_view', {
    //   firebase_screen: 'Lab_results_history',
    //   lab_results_history_type: category,
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  let testMeasurements: [string, TestMeasurement[]][] = [];
  if (category) {
    testMeasurements = groupByYear(createMeasurements(hashimotoTestHistory, category));
  }

  const renderCategoryFilter = () => {
    const categories = [
      HashimotoTestMeasurementFieldEnum.TSH,
      HashimotoTestMeasurementFieldEnum.FT3,
      HashimotoTestMeasurementFieldEnum.FT4,
      HashimotoTestMeasurementFieldEnum.ANTI_TG,
      HashimotoTestMeasurementFieldEnum.ANTI_TPO,
    ];

    return (
      <div className="sub-navigation">
        <Container>
          <Nav className="d-block">
            {categories.map((cat) => (
              <NavItem key={cat}>
                <NavLink
                  to={`/lab-tests/history/${cat}`}
                  replace={true}
                  className={category === cat ? 'nav-link active' : 'nav-link'}
                >
                  {t(`labTests.${cat}`)}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Container>
      </div>
    );
  };

  return (
    <Layout>
      <div className="page-template-lab-tests full-height2">
        <TitleBar>{t('labTestsHistory.navbarTitle')}</TitleBar>
        {renderCategoryFilter()}
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }}>
              <div className="lab-tests-container">
                <LabTestsHistoryItem
                  testMeasurements={testMeasurements}
                  category={category}
                  removeTest={removeTest}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default withLoading(TestsHistoryContainer, TestsHistoryPlaceholder);
